export default "__VITE_ASSET__C2hFiMX0__"